import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComics = comics.filter((c) => c.featured);

  return (
    <section className="relative w-full overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20artistic%20abstract%20background%2C%20warm%20gradient%20tones%20of%20coral%20and%20amber%2C%20soft%20ink%20wash%20style%2C%20ethereal%20atmosphere%2C%20subtle%20comic%20panel%20texture%2C%20clean%20elegant%20design%2C%20no%20text%2C%20modern%20minimal%20illustration%2C%20dreamy%20artistic%20aesthetic%2C%20warm%20gentle%20lighting&width=1600&height=800&seq=hero-bg-manhwa&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto pt-20 pb-16 md:pt-28 md:pb-24">
          <div className="text-center mb-12">
            <h1 id="hero-heading" className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 tracking-wide">
              好看的韩国漫画，韩漫在线免费阅读
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
              尾巴漫画网专注韩国漫画在线免费阅读，高清无删减内容，每日更新热门韩漫，
              <br className="hidden md:block" />
              下拉式设计让您沉浸其中，畅享极致阅读体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {featuredComics.slice(0, 3).map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group relative rounded-2xl overflow-hidden bg-black/20 backdrop-blur-sm border border-white/10 hover:border-white/30 transition-all duration-500 hover:scale-[1.02]"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 推荐韩国漫画`}
                    title={`${comic.title} - 韩漫推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="bg-accent-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap">
                      推荐
                    </span>
                    <span className="text-white/70 text-xs whitespace-nowrap">{comic.categoryName}</span>
                  </div>
                  <h3 className="text-lg font-bold text-white mb-1">{comic.title}</h3>
                  <p className="text-sm text-white/70 line-clamp-1">{comic.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}